import BaseStore from '@src/utils/store/base-store';
import { observable, action } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import message from '@src/components/common-message';
import { detectDevice } from '@src/utils/common-util';
import createPinchZoomHandler from '@src/utils/pinch-zoom-handler';

class MainStore extends BaseStore {
  @observable contentId = '';

  // // 文章标题
  @observable article_title = '';

  // 文章内容
  @observable content = '';

  //当前语音
  @observable lang = '';

  //是否显示预览遮罩层
  @observable previewVisible = false;

  //当前预览的图片地址
  @observable previewSrc = '';

  // 图片预览的 CSS transform 值，由触摸事件动态更新
  @observable previewTransform = '';

  // 是否为移动端设备
  isMobile = detectDevice() === 'mobile';

  //手势处理器实例
  pinchZoomHandler = createPinchZoomHandler({
    // 驱动视图重新渲染
    onChange: transform => {
      this.previewTransform = transform;
    }
  });

  /**
   * 图片点击事件处理
   * 通过事件委托监听内容区域的点击，当点击目标为图片时打开全屏预览
   */
  handleImageClick = e => {
    if (!this.isMobile) return;
    const img = e.target;
    if (img.tagName === 'IMG' && img.src) {
      this.previewSrc = img.src;
      this.previewVisible = true;
      this.previewTransform = this.pinchZoomHandler.getInitialTransform();
    }
  };

  /**
   * 关闭图片预览
   */
  @action
  closePreview = () => {
    if (this.pinchZoomHandler.isMoved()) {
      this.pinchZoomHandler.clearMoved();
      return;
    }
    this.previewVisible = false;
    this.previewSrc = '';
    this.previewTransform = this.pinchZoomHandler.getInitialTransform();
    this.pinchZoomHandler.reset();
  };

  /**
   * 获取文章详细信息
   * @param {string} contentId - 文章ID
   */
  getArticleDetail = async (contentId, lang) => {
    try {
      const { content } = await this.$ztService.getArticleDetail({ contentId, lang });

      // /**
      //  * 设置文章标题
      //  * @param {string} title - 文章标题
      //  */
      this.article_title = content.title;
      // /**
      //  * 设置文章内容
      //  * @param {string} content - 文章内容
      //  */
      this.content = content.content;
    } catch (error) {
      message.fail(error?.message);
    }
  };

  use() {
    super.use();
    const urlParams = new URLSearchParams(window.location.search);
    this.contentId = urlParams.get('contentId');
    this.lang = urlParams.get('lang');
    useMount(() => {
      // 测试contentID: slsaa5curksh
      if (this.contentId && this.lang) {
        this.getArticleDetail(this.contentId, this.lang);
      } else {
        message.fail('no data', 3000);
      }
    });
  }
}

export default MainStore;
